import { useEffect } from 'react'
import type L from 'leaflet'

interface UsePinModeProps {
  mapRef: React.MutableRefObject<L.Map | null>
  isInitializedRef: React.MutableRefObject<boolean>
  pinMode: boolean
  onMapClick?: (lat: number, lon: number) => void
}

export const usePinMode = ({
  mapRef,
  isInitializedRef,
  pinMode,
  onMapClick,
}: UsePinModeProps) => {
  useEffect(() => {
    if (!mapRef.current || !isInitializedRef.current) return

    const map = mapRef.current
    const container = map.getContainer()

    if (pinMode) {
      container.style.cursor = 'crosshair'
      container.classList.add('pin-mode-active')

      const handlePinClick = (e: L.LeafletMouseEvent) => {
        if (onMapClick) {
          onMapClick(e.latlng.lat, e.latlng.lng)
        }
      }

      map.on('click', handlePinClick)

      return () => {
        container.style.cursor = ''
        container.classList.remove('pin-mode-active')
        map.off('click', handlePinClick)
      }
    } else {
      container.style.cursor = ''
      container.classList.remove('pin-mode-active')
    }
  }, [pinMode, onMapClick, mapRef, isInitializedRef])
}
